
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import OurStory from './components/OurStory';
import Values from './components/Values';
import TeamSection from './components/TeamSection';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <OurStory />
      <Values />
      <TeamSection />
      <Footer />
    </div>
  );
}
